'use strict';

/**
 * Configuration de UI Bootstrap pour corriger les problèmes d'accessibilité
 */
import appModule from '../app.module';

angular.module(appModule)
  .config(['$uibModalProvider', function($uibModalProvider) {
    $uibModalProvider.options.appendTo = function(elem) {
      // Utiliser un conteneur dédié pour les modales au lieu du body
      var modalContainer = document.getElementById('modal-container');
      if (!modalContainer) {
        modalContainer = document.createElement('div');
        modalContainer.id = 'modal-container';
        document.body.appendChild(modalContainer);
      }
      return modalContainer;
    };

    // Personnaliser le gestionnaire de focus pour éviter les problèmes d'accessibilité
    $uibModalProvider.options.ariaDescribedBy = false;
    $uibModalProvider.options.ariaLabelledBy = false;
  }])
  .run(['$templateCache', function($templateCache) {
    // Personnaliser le template modal pour supprimer les attributs aria problématiques
    var modalWindowTemplate = $templateCache.get('uib/template/modal/window.html');
    if (modalWindowTemplate) {
      // Modifier le template pour éviter l'ajout d'aria-hidden sur les parents
      var modifiedTemplate = modalWindowTemplate
        .replace('aria-hidden="true"', '');
      
      $templateCache.put('uib/template/modal/window.html', modifiedTemplate);
    }
  }]);
